export default "__VITE_ASSET__DPYR0GiP__"